import { t } from "@lingui/core/macro";
import type { RefinementListItem } from "instantsearch.js/es/connectors/refinement-list/connectRefinementList";

type AlgoliaProcessableItem = RefinementListItem;

// NOTE: this is an hack to resolve the algolia infinite loop with anonymous functions
let staticDayGroupItemsTransformer;
export const dayGroupItemsTransformer = (): ((
  items: AlgoliaProcessableItem[]
) => AlgoliaProcessableItem[]) => {
  if (!staticDayGroupItemsTransformer) {
    staticDayGroupItemsTransformer = (
      items: AlgoliaProcessableItem[]
    ): AlgoliaProcessableItem[] => {
      const transformedItems = [...items]
        .sort((a, b) => {
          const aValue = parseInt(a.label.split(" - ", 2)[0], 10);
          const bValue = parseInt(b.label.split(" - ", 2)[0], 10);
          return aValue - bValue;
        })
        .map((item) => ({
          ...item,
          label: `${item.label} ${t`days`}`
        }));
      return transformedItems;
    };
  }
  return staticDayGroupItemsTransformer;
};

let staticNameSortingTransformer;
export const nameSortingTransformer = (): ((
  items: AlgoliaProcessableItem[]
) => AlgoliaProcessableItem[]) => {
  if (!staticNameSortingTransformer) {
    staticNameSortingTransformer = (items) => {
      const transformedItems = [...items].sort((a, b) => {
        return a.label.localeCompare(b.label);
      });
      return transformedItems;
    };
  }
  return staticNameSortingTransformer;
};
